/**
 * 車両
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/search/vehicles`

const search_vehicle = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    index () {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH).then(data => {
          resolve(data.content)
        })
      })
    },
    search ({ _commit }, { registered_number }) {
      let params = { registered_number: registered_number }
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},
}
export default search_vehicle
